export {default} from './AtlasMarker';
